class Th
{
    constructor()
    {
        this.general = {
            prospective: "ผู้สนใจเข้าศึกษา",
            student: "นักศึกษา",
            alumni: "ศิษย์เก่า",
            parent: "ผู้ปกครอง",
            person: "บุคคลภายนอก",
            staff: "บุคลากร",
        }

        this.organization = {
            edu: "คณะครุศาสตร์",
            ait: "คณะเทคโนโลยีการเกษตรและเทคโนโลยีอุตสาหกรรม",
            hss: "คณะมนุษยศาสตร์และสังคมศาสตร์",
            ms: "คณะวิทยาการจัดการ",
            sci: "คณะวิทยาศาสตร์และเทคโนโลยี",
            op: "สำนักงานอธิการบดี",
            apr: "สำนักส่งเสริมวิชาการและงานทะเบียน",
            aritc: "สำนักวิทยบริการและเทคโนโลยีสารสนเทศ",
            artculture: "สำนักศิลปะและวัฒนธรรม",
            rdi: "สถาบันวิจัยและพัฒนา",
        }

        this.mainmenu = {
            home: "หน้าหลัก",

            intro: "แนะนำมหาวิทยาลัย",
            organization: "คณะและหน่วยงาน",
            education: "การศึกษา",
            service: "บริการ",

            forProspective: "สำหรับผู้สนใจเข้าศึกษา",
            forStudent: "สำหรับนักศึกษา",
            forAlumni: "สำหรับศิษย์เก่า",
            forParent: "สำหรับผู้ปกครอง",
            forPerson: "สำหรับบุคคลภายนอก",
            forStaff: "สำหรับบุคลากร",

            otherOrganization: "หน่วยงานอื่นๆ",
        }
    }
}

export default Th
